import type { SettingsOperation } from '@veem/crm-schema'

const SUCCESS: Partial<Record<SettingsOperation, string>> = {
  updateStage: 'Статус оновлено',
  moveStage: 'Порядок статусів змінено',
  moveRouteStage: 'Порядок етапів змінено',
  moveWorkCenter: 'Порядок дільниць змінено',
  updateCompany: 'Компанію оновлено',
  updateCompanyProfile: 'Бланк компанії збережено',
  removeCompanyFile: 'Зображення прибрано',
  setCurrencyActive: 'Доступність валюти змінено',
  makeDefaultVat: 'Режим ПДВ за замовчуванням змінено',
  setVatActive: 'Доступність режиму ПДВ змінено',
  updateVatMode: 'Режим ПДВ оновлено',
  restoreLocation: 'Місце повернуто з архіву',
  restoreCategory: 'Категорію повернуто з архіву',
  updateUnit: 'Одиницю оновлено',
}

export const settingsSuccess = (
  operation: SettingsOperation,
  input: unknown,
): string | undefined => {
  if (operation === 'updateRouteStage') {
    const patch = (input as { patch?: { archived?: boolean } }).patch
    return patch?.archived === undefined ? 'Етап оновлено' : undefined
  }
  return SUCCESS[operation]
}
